export default {
    // Header Section
    "discover_your": "మీ దాన్ని కనుగొనండి",
    "love_report": "ప్రేమ నివేదిక",
    "cosmic_love_insights": "కాస్మిక్ ప్రేమ అంతర్దృష్టులు",
    "love_report_description": "ప్రేమ మరియు వివాహంలో స్పష్టత కావాలా? వేద జ్యోతిష్యం ఆధారంగా సమగ్ర విశ్లేషణతో మీ భవిష్యత్తు, వివాహ సమయం మరియు ఆత్మసహచరి లక్షణాలను తెలుసుకోండి.",

    // Service Information
    "enter_details_for_love_analysis": "ప్రేమ విశ్లేషణ కోసం మీ వివరాలను నమోదు చేయండి",
    "complete_love_analysis": "పూర్ణ ప్రేమ విశ్లేషణ",
    "service_price": "సేవా ధర",
    "comprehensive_love_analysis_note": "మీ శృంగార సంభావ్యత మరియు సంబంధ అనుకూలత లోతైన విశ్లేషణ",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
    "name_love_vibration": "మీ పేరు మీ శృంగార కంపనలు మరియు ఆకర్షణ నమూనాలను ప్రభావితం చేస్తుంది",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబరును నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_love_compatibility": "మీ ప్రేమ మరియు అనుకూలత నమూనాలను నిర్ధారించడానికి అవసరం",
    "time_of_birth": "జన్మ సమయం",
    "exact_time_critical_for_love": "ఖచ్చితమైన శుక్ర మరియు 7వ భావ గణనల కోసం ఖచ్చితమైన సమయం అవసరం",
    "place_of_birth": "జన్మ స్థలం",
    "place_of_birth_placeholder": "నగరం, రాష్ట్రం, దేశం",
    "location_essential_for_love": "స్థానం ప్రేమ మరియు సంబంధాలను ప్రభావితం చేసే గ్రహ స్థానాలను ప్రభావితం చేస్తుంది",
    "preferred_language": "ప్రాధాన్య భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ ప్రేమ విశ్లేషణ ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core Love Features
    "love_compatibility_analysis": "మీ ప్రేమ జీవిత విశ్లేషణ",
    "relationship_potential_insights": "సంబంధ సంభావ్యత అంతర్దృష్టులు",
    "marriage_timing_predictions": "వివాహ సమయ భవిష్యవాణులు",
    "soulmate_identification": "ఆత్మ సహచరుడి గుర్తింపు",
    "romantic_guidance_tips": "శృంగార మార్గదర్శన చిట్కాలు",
    "pdf_download": "సమగ్ర PDF నివేదిక",

    "what_you_get": "మీ ప్రేమ విశ్లేషణలో ఉన్నవి",
    "comprehensive_love_chart": "సమగ్ర ప్రేమ చార్ట్",
    "romantic_compatibility_score": "శృంగార అనుకూలత స్కోర్",
    "relationship_guidance": "సంబంధ మార్గదర్శనం",
    "marriage_timing_insights": "వివాహ సమయ అంతర్దృష్టులు",

    // Actions & Buttons
    "pay_and_generate_analysis_love": "నా ప్రేమ విశ్లేషణ పొందండి",
    "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తోంది",
    "processing_request": "విశ్లేషణను రూపొందిస్తోంది",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "love_analysis_processing": "మీ ప్రేమ విశ్లేషణ మా నిపుణ సంబంధ జ్యోతిష్యులచే తయారు చేయబడుతోంది. మీ శృంగార విధి మరియు అనుకూలత నమూనాలపై వివరణాత్మక అంతర్దృష్టులు అందుకుంటారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "చెల్లింపు ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "విశ్లేషణ డెలివరీ",
    "within_12_hours_delivery_note_love": "మీ వివరణాత్మక ప్రేమ నివేదిక 24 గంటలలోపు తయారవుతుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్‌లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్‌లను అందుకోండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి విశ్లేషణ అందించబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ ప్రేమ విశ్లేషణ ప్యాకేజ్",
    "detailed_love_report": "సమగ్ర ప్రేమ నివేదిక (PDF)",
    "compatibility_analysis_detailed": "వివరణాత్మక అనుకూలత విశ్లేషణ",
    "relationship_timing_predictions": "సంబంధ సమయ భవిష్యవాణులు",
    "soulmate_characteristics": "ఆత్మ సహచరుడి లక్షణాల వివరణ",
    "romantic_enhancement_tips": "శృంగార మెరుగుదల చిట్కాలు",

    // Visual Content
    "sample_love_analysis": "నమూనా ప్రేమ విశ్లేషణ",
    "love_compatibility_score": "మీ ప్రేమ జీవిత స్కోర్",
    "sample_love_reading": "లోతైన భావోద్వేగ సంబంధంతో అధిక శృంగార సంభావ్యత",
    "sample_love_preview": "అనుకూలత అంతర్దృష్టులతో మీ వ్యక్తిగత ప్రేమ విశ్లేషణ మునుజూపు",
    "love_analysis_categories": "ప్రేమ విశ్లేషణ వర్గాలు",

    // Love Category Types
    "compatibility": "అనుకూలత",
    "romance": "శృంగారం",
    "marriage": "వివాహం",
    "soulmate": "ఆత్మ సహచరుడు",
    "attraction": "ఆకర్షణ",
    "passion": "అభిరుచి",

    // Status & Processing
    "your_love_analysis_status": "మీ ప్రేమ విశ్లేషణ స్థితి",
    "processing_your_analysis": "మీ ప్రేమ నమూనాలను విశ్లేషిస్తోంది",
    "analysis_processing_message": "మా సంబంధ జ్యోతిష్య నిపుణులు మీ శృంగార అనుకూలత మరియు ప్రేమ విధిని నిర్ధారించడానికి మీ శుక్ర స్థానం మరియు 7వ భావాన్ని అధ్యయనం చేస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో ఉంది",
    "pending": "వేచి ఉంది",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్‌లు ప్రారంభించబడ్డాయి",
    "delivery_within_12_hours": "12 గంటలలోపు నివేదిక సిద్ధం",

    // Support & Contact
    "contact_support": "ప్రేమ మద్దతును సంప్రదించండి",
    "need_help": "మార్గదర్శనం కావాలా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అవసరమైన అన్ని జన్మ వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "విశ్లేషణ ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Love-Specific Elements
    "seventh_house": "7వ భావం (వివాహ భావం)",
    "venus_position": "శుక్ర స్థానం మరియు ప్రభావం",
    "mars_influence": "మంగళ మరియు అభిరుచి సూచికలు",
    "moon_emotions": "చంద్ర మరియు భావోద్వేగ అనుకూలత",
    "jupiter_blessings": "ప్రేమలో గురు ఆశీర్వాదాలు",
    "love_yogas": "ప్రేమ మరియు వివాహ యోగాలు",

    // Compatibility Analysis
    "zodiac_compatibility": "రాశి చిహ్న అనుకూలత",
    "nakshatra_matching": "నక్షత్ర అనుకూలత",
    "guna_milan": "గుణ మిలన్ విశ్లేషణ",
    "doshas_matching": "దోష అనుకూలత తనిఖీ",
    "planetary_harmony": "గ్రహ సామరస్య స్కోర్",
    "elemental_compatibility": "మూలకార్ణ అనుకూలత",

    // Love Personality Analysis
    "romantic_nature": "శృంగార స్వభావం మరియు శైలి",
    "love_language": "మీ ప్రేమ భాష",
    "emotional_needs": "సంబంధాలలో భావోద్వేగ అవసరాలు",
    "attraction_patterns": "ఆకర్షణ నమూనాలు",
    "relationship_approach": "సంబంధ దృక్పథ శైలి",
    "commitment_style": "నిబద్ధత మరియు విశ్వసనీయత శైలి",

    // Soulmate Analysis
    "soulmate_characteristics": "ఆత్మ సహచరుడి లక్షణాలు",
    "ideal_partner_traits": "అనువైన భాగస్వామి లక్షణాలు",
    "soulmate_timing": "మీ ఆత్మ సహచరుడిని ఎప్పుడు కలుస్తారు",
    "recognition_signs": "ఆత్మ సహచరుడి గుర్తింపు సంకేతాలు",
    "karmic_connections": "కర్మ ప్రేమ సంబంధాలు",
    "twin_flame_indicators": "జంట జ్వాల సూచికలు",

    // Marriage Predictions
    "marriage_timing": "వివాహ సమయ భవిష్యవాణులు",
    "wedding_auspicious_dates": "మంగళకరమైన వివాహ తేదీలు",
    "married_life_forecast": "వైవాహిక జీవిత అంచనా",
    "spouse_characteristics": "జీవిత భాగస్వామి లక్షణాలు",
    "marriage_compatibility": "వివాహ అనుకూలత స్కోర్",
    "family_harmony": "కుటుంబ సామరస్య అవకాశాలు",

    // Relationship Phases
    "dating_guidance": "డేటింగ్ దశ మార్గదర్శనం",
    "courtship_period": "ప్రేమికుల కాలం అంతర్దృష్టులు",
    "engagement_timing": "నిశ్చితార్థ సమయం",
    "pre_marriage_guidance": "వివాహ పూర్వ మార్గదర్శనం",
    "honeymoon_phase": "హనీమూన్ దశ భవిష్యవాణులు",
    "long_term_relationship": "దీర్ఘకాలిక సంబంధ అంచనా",

    // Love Challenges & Solutions
    "relationship_challenges": "సంభావ్య సంబంధ సవాళ్లు",
    "compatibility_issues": "పరిష్కరించవలసిన అనుకూలత సమస్యలు",
    "communication_style": "కమ్యూనికేషన్ శైలి మ్యాచ్",
    "conflict_resolution": "వివాద పరిష్కార మార్గదర్శనం",
    "trust_building": "నమ్మకం నిర్మాణ వ్యూహాలు",
    "intimacy_enhancement": "సాన్నిహిత్య మెరుగుదల చిట్కాలు",

    // Romantic Timing
    "love_favorable_periods": "ప్రేమ అనుకూల కాలాలు",
    "romantic_peak_times": "శృంగార శిఖర సమయాలు",
    "proposal_timing": "అత్యుత్తమ ప్రపోజల్ సమయం",
    "relationship_milestones": "సంబంధ మైలురాయి సమయం",
    "anniversary_significance": "వార్షికోత్సవ ప్రాధాన్యత",
    "renewal_periods": "సంబంధ పునరుద్ధరణ కాలాలు",

    // Venus Analysis
    "venus_sign_influence": "శుక్ర రాశి ప్రభావం",
    "venus_house_position": "శుక్ర భావ స్థానం",
    "venus_aspects": "శుక్ర గ్రహ దృష్టులు",
    "venus_dignity": "శుక్ర బలం మరియు గౌరవం",
    "venus_remedies": "శుక్ర మెరుగుదల పరిహారాలు",
    "venus_mantras": "శుక్ర ప్రేమ మంత్రాలు",

    // Love Types & Styles
    "passionate_love": "అభిరుచిపూర్వక ప్రేమ సూచికలు",
    "companionate_love": "సహచర ప్రేమ శైలి",
    "romantic_love": "శృంగార ప్రేమ వ్యక్తీకరణ",
    "unconditional_love": "షరతులు లేని ప్రేమ సామర్థ్యం",
    "spiritual_love": "ఆధ్యాత్మిక ప్రేమ సంబంధం",
    "platonic_relationships": "ప్లేటోనిక్ సంబంధ అంతర్దృష్టులు",

    // Compatibility Factors
    "mental_compatibility": "మానసిక అనుకూలత",
    "emotional_compatibility": "భావోద్వేగ అనుకూలత",
    "physical_compatibility": "శారీరక అనుకూలత",
    "spiritual_compatibility": "ఆధ్యాత్మిక అనుకూలత",
    "lifestyle_compatibility": "జీవనశైలి అనుకూలత",
    "financial_compatibility": "వివాహంలో ఆర్థిక అనుకూలత",

    // Love Remedies
    "love_enhancing_remedies": "ప్రేమ మెరుగుదల పరిహారాలు",
    "relationship_healing": "సంబంధ వైద్య అభ్యాసాలు",
    "attraction_remedies": "ఆకర్షణ మెరుగుదల పరిహారాలు",
    "marriage_delay_remedies": "వివాహ ఆలస్యం పరిహారాలు",
    "love_gemstones": "ప్రేమ మరియు సంబంధ రత్నాలు",
    "romantic_rituals": "శృంగార కర్మలు మరియు అభ్యాసాలు",

    // Past Life & Karma
    "past_life_love_connections": "పూర్వ జన్మ ప్రేమ సంబంధాలు",
    "karmic_relationships": "కర్మ సంబంధ నమూనాలు",
    "soul_contracts": "ప్రేమలో ఆత్మ ఒప్పందాలు",
    "karmic_debt_love": "సంబంధాలలో కర్మ రుణం",
    "spiritual_lessons_love": "ప్రేమ ద్వారా ఆధ్యాత్మిక పాఠాలు",
    "past_life_spouse": "పూర్వ జన్మ జీవిత భాగస్వామి సంబంధాలు",

    // Love Forecast
    "monthly_love_forecast": "మాసిక ప్రేమ అంచనా",
    "yearly_romance_predictions": "వార్షిక శృంగార భవిష్యవాణులు",
    "love_life_phases": "ప్రేమ జీవిత దశలు",
    "relationship_cycles": "సంబంధ చక్రాలు",
    "romantic_opportunities": "ముందు వచ్చే శృంగార అవకాశాలు",
    "love_life_transformation": "ప్రేమ జీవిత రూపాంతర కాలాలు",

    // Special Love Scenarios
    "second_marriage": "రెండవ వివాహ అవకాశాలు",
    "late_marriage": "ఆలస్యమైన వివాహ భవిష్యవాణులు",
    "love_marriage_vs_arranged": "ప్రేమ వివాహం వర్సెస్ కుటుంబ వివాహం",
    "intercaste_marriage": "కులాంతర వివాహ అవకాశాలు",
    "foreign_spouse": "విదేశీ జీవిత భాగస్వామి అవకాశాలు",
    "celebrity_romance": "ప్రముఖ వ్యక్తుల శృంగార సూచికలు",

    // Relationship Counseling
    "pre_marital_counseling": "వివాహ పూర్వ జ్యోతిష్య కౌన్సెలింగ్",
    "relationship_therapy": "జ్యోతిష్య సంబంధ చికిత్స",
    "couple_compatibility": "జంట అనుకూలత మెరుగుదల",
    "marriage_counseling": "వివాహ కౌన్సెలింగ్ అంతర్దృష్టులు",
    "relationship_revival": "సంబంధ పునరుజ్జీవన మార్గదర్శనం",
    "love_life_coaching": "ప్రేమ జీవిత కోచింగ్",

    // Advanced Love Analysis
    "composite_chart_analysis": "సంయుక్త చార్ట్ విశ్లేషణ",
    "synastry_compatibility": "సిన్‌యాస్ట్రీ అనుకూలత రీడింగ్",
    "davison_relationship_chart": "డేవిసన్ సంబంధ చార్ట్",
    "progressed_love_indicators": "ప్రగతిశీల ప్రేమ సూచికలు",
    "solar_return_love": "సౌర రిటర్న్ ప్రేమ భవిష్యవాణులు",
    "lunar_return_romance": "చంద్ర రిటర్న్ శృంగార అంతర్దృష్టులు"
};
